import React from 'react';
import * as listCardsStyle from '../../styles/internal-page/listCards.module.scss';
import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {normalizeString} from '../../utils/utils';
import IconContainer from '../shared/IconContainer';


const ListCards = ({ content }) => {
  const {t} = useTranslation();

  const lstCardsId =
    normalizeString(t('product.anchor.CmsExEdProductBlocComponentSimilarProducts'))
      .replace(/ /g, '_').toLowerCase();


  return (
    <div className={listCardsStyle.root}
      id={lstCardsId}
    >
      <h2>{t('exed.product.products.title')}</h2>
      <div className={listCardsStyle.container}>
        {content.cards.map((elem, index) => (
          <Link className={listCardsStyle.card}
            key={index + 'CardList'}
            to={elem.url}
          >
            {getImage(elem.thumbnail?.imageFile) &&
              <GatsbyImage
                alt={''}
                className={listCardsStyle.image}
                image={getImage(elem.thumbnail?.imageFile)}
                loading="eager"
              />
            }
            {!getImage(elem.thumbnail?.imageFile) &&
              <StaticImage
                alt=""
                className={listCardsStyle.image}
                src="../../static/images/default-exed-card.png"
              />
            }
            <div className={listCardsStyle.category}>
              <p className={listCardsStyle.categoryText}>
                {elem.format.label}
              </p>
            </div>
            <div className={listCardsStyle.bottomCard}>
              <p className={listCardsStyle.titleCard}>
                {elem.title}
              </p>
              {elem.related_content?.duration?.duration &&
                <div className={listCardsStyle.duration}>
                  <IconContainer
                    color="WHITE"
                    icon="CLOCK"
                    size={25}
                  />
                  <p className={listCardsStyle.day}>
                    {t('exed.product.products.duration') + ' '}
                    {elem.related_content?.duration.duration + ' ' + t('exed.product.products.duration-days')}
                  </p>
                </div>
              }
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

ListCards.propTypes = {
  content: PropTypes.shape({
    cards: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired,
      thumbnail: PropTypes.shape({
        imageFile: PropTypes.object,
      }),
      format: PropTypes.shape({
        label: PropTypes.string.isRequired,
      }).isRequired,
      related_content: PropTypes.shape({
        duration: PropTypes.shape({
          duration: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
          ]),
        }),
      }),
      title: PropTypes.string.isRequired,
      nextApplicationDeadline: PropTypes.string,
      nextSessionDate: PropTypes.string,
      nextSessionPlace: PropTypes.string,
    })).isRequired,
  }).isRequired,
};

export default ListCards;